import React, { useEffect } from 'react';
import Services from './Services'
import Aboutus from './Aboutus'
import MainBanner from './MainBanner'
import Stack from './Stack'
import Whychoose from './Whychoose'
//  import Gallery from './Gallery'
import ContactForm from './ContactForm';
import Homegeleery from './Homegeleery';
import Newaboutcompony from './Newaboutcompony';
import NewwhychosesUS from './NewwhychosesUS';
import Testmonial from './Testmonial';
import OurLeadership from './OurLeadership';
import Ourclints from './Ourclints';
import HoveredCards from './HoveredCards';
import AllvariousCards from './AllvariousCards';
import Homesecondslidercards from './Homesecondslidercards';
import Homesliderdata from './Homesliderdata';
const Home = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs 

  


  return (
    <div style={{backgroundColor:'white'}}>
      <MainBanner />
      {/* <Stack /> */}
      <Services />

      <NewwhychosesUS />
      {/* <Homegeleery /> */}
      {/* <Ourclints /> */}

      {/* <Homesliderdata /> */}
      {/* <AllvariousCards /> */}
      {/* <Homesecondslidercards /> */}
      <HoveredCards />


    </div>
  )
}

export default Home